import { useQuery } from '@tanstack/react-query';
import { AdvancedFilterPanel } from '@/components/common/AdvancedFilter';
import { promoItemsQueryOptions } from '@/features/promotion/api/promotion.api';
import { zonalManagersQueryOptions } from '@/features/users/api/users.api';
import type { UrlSyncedFilters } from '@/hooks/useUrlSyncedFilters';
import { getDateFromToFilterFields, getZonalManagerFilterField } from '@/utils/filterFields';
import { DONATION_ITEM_LOOKUP_PARAMS } from '../constants/marketPromotion.constants';
import {
  getDecisionStatusFilterField,
  getDonationContactFilterFields,
  getDonationItemsFilterField,
} from '../utils/mpFilterFields';

interface DonationApprovalFilterPanelProps {
  filters: UrlSyncedFilters;
}

export function DonationApprovalFilterPanel({ filters }: DonationApprovalFilterPanelProps) {
  const { filterValues, defaultFilterValues, handleFilterChange } = filters;

  const { data: zonalManagers } = useQuery(zonalManagersQueryOptions());
  const { data: items } = useQuery(promoItemsQueryOptions(DONATION_ITEM_LOOKUP_PARAMS));

  return (
    <AdvancedFilterPanel
      fields={[
        ...getDateFromToFilterFields(),
        getZonalManagerFilterField(zonalManagers, 'enteredBy'),
        getDecisionStatusFilterField(),
        getDonationItemsFilterField(items?.data),
        ...getDonationContactFilterFields(),
      ]}
      values={filterValues}
      defaultValues={defaultFilterValues}
      onChange={handleFilterChange}
    />
  );
}
